import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateAttachmentResponse } from '@responses/attachments';
import axios from 'axios';

import { getCurrentDocumentApiUrl } from './getCurrentDocumentApiUrl';

const ATTACHMENT_DOCUMENT_UPLOAD_URI = 'attachments';

interface GetAttachmentDocumentPresignedUrlOptions {
  block_type?: 'block' | 'summary_block';
  endorsementId?: string;
  fileName: string;
  name: string;
  order?: number;
  section_id?: string;
  size: number;
  submissionId?: string;
  templateId?: string;
  type?: 'pre' | 'post';
}

export const getAttachmentDocumentPresignedUrl = async ({
  block_type,
  endorsementId,
  fileName,
  name,
  order,
  section_id,
  size,
  submissionId,
  templateId,
  type,
}: GetAttachmentDocumentPresignedUrlOptions) => {
  const url = [getCurrentDocumentApiUrl(templateId, submissionId, endorsementId), ATTACHMENT_DOCUMENT_UPLOAD_URI].join(
    '/',
  );

  if (!url) {
    return;
  }

  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url,
    data: {
      fileName,
      name,
      size,
      type,
      section_id,
      order,
      block_type,
    },
  });

  const response = await axios<CreateAttachmentResponse>(networkPayload);
  return response;
};
